<template>
  <div>
    <v-dialog persistent v-model="show" width="400" eager>
      <v-card>
        <v-card-title class="justify-space-between d-flex align-start">
          <div class="text-wrap confirmation-dialog-title">{{ title }}</div>
          <v-btn fab text small @click="$emit('closeDialog')"
            ><v-icon class="text-right">close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <p>{{ content }}</p>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-btn
            color="primary"
            depressed
            block
            large
            class="text-body-1 mb-4"
            @click="handleClick"
            >{{ buttonText }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import "vue2-dropzone/dist/vue2Dropzone.min.css";


export default {
  props: {
    show: { type: Boolean },
    title: { type: String },
    content: { type: String },
    buttonText: { type: String },
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style>
.confirmation-dialog-title {
  max-width: 85%;
}
</style>
